/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createMeal = /* GraphQL */ `
  mutation CreateMeal(
    $input: CreateMealInput!
    $condition: ModelMealConditionInput
  ) {
    createMeal(input: $input, condition: $condition) {
      id
      date
      timing
      protein
      fat
      carbs
      calories
      salt
      iron
      vitaminA
      vitaminB1
      vitaminB2
      vitaminC
      vitaminD
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateMeal = /* GraphQL */ `
  mutation UpdateMeal(
    $input: UpdateMealInput!
    $condition: ModelMealConditionInput
  ) {
    updateMeal(input: $input, condition: $condition) {
      id
      date
      timing
      protein
      fat
      carbs
      calories
      salt
      iron
      vitaminA
      vitaminB1
      vitaminB2
      vitaminC
      vitaminD
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteMeal = /* GraphQL */ `
  mutation DeleteMeal(
    $input: DeleteMealInput!
    $condition: ModelMealConditionInput
  ) {
    deleteMeal(input: $input, condition: $condition) {
      id
      date
      timing
      protein
      fat
      carbs
      calories
      salt
      iron
      vitaminA
      vitaminB1
      vitaminB2
      vitaminC
      vitaminD
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createUserCharacter = /* GraphQL */ `
  mutation CreateUserCharacter(
    $input: CreateUserCharacterInput!
    $condition: ModelUserCharacterConditionInput
  ) {
    createUserCharacter(input: $input, condition: $condition) {
      id
      characterId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateUserCharacter = /* GraphQL */ `
  mutation UpdateUserCharacter(
    $input: UpdateUserCharacterInput!
    $condition: ModelUserCharacterConditionInput
  ) {
    updateUserCharacter(input: $input, condition: $condition) {
      id
      characterId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteUserCharacter = /* GraphQL */ `
  mutation DeleteUserCharacter(
    $input: DeleteUserCharacterInput!
    $condition: ModelUserCharacterConditionInput
  ) {
    deleteUserCharacter(input: $input, condition: $condition) {
      id
      characterId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRecipe = /* GraphQL */ `
  mutation CreateRecipe(
    $input: CreateRecipeInput!
    $condition: ModelRecipeConditionInput
  ) {
    createRecipe(input: $input, condition: $condition) {
      id
      title
      description
      isPublic
      imageUrl
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecipe = /* GraphQL */ `
  mutation UpdateRecipe(
    $input: UpdateRecipeInput!
    $condition: ModelRecipeConditionInput
  ) {
    updateRecipe(input: $input, condition: $condition) {
      id
      title
      description
      isPublic
      imageUrl
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecipe = /* GraphQL */ `
  mutation DeleteRecipe(
    $input: DeleteRecipeInput!
    $condition: ModelRecipeConditionInput
  ) {
    deleteRecipe(input: $input, condition: $condition) {
      id
      title
      description
      isPublic
      imageUrl
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createIngredient = /* GraphQL */ `
  mutation CreateIngredient(
    $input: CreateIngredientInput!
    $condition: ModelIngredientConditionInput
  ) {
    createIngredient(input: $input, condition: $condition) {
      id
      recipeId
      name
      amount
      unit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateIngredient = /* GraphQL */ `
  mutation UpdateIngredient(
    $input: UpdateIngredientInput!
    $condition: ModelIngredientConditionInput
  ) {
    updateIngredient(input: $input, condition: $condition) {
      id
      recipeId
      name
      amount
      unit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteIngredient = /* GraphQL */ `
  mutation DeleteIngredient(
    $input: DeleteIngredientInput!
    $condition: ModelIngredientConditionInput
  ) {
    deleteIngredient(input: $input, condition: $condition) {
      id
      recipeId
      name
      amount
      unit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createStep = /* GraphQL */ `
  mutation CreateStep(
    $input: CreateStepInput!
    $condition: ModelStepConditionInput
  ) {
    createStep(input: $input, condition: $condition) {
      id
      recipeId
      order
      description
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateStep = /* GraphQL */ `
  mutation UpdateStep(
    $input: UpdateStepInput!
    $condition: ModelStepConditionInput
  ) {
    updateStep(input: $input, condition: $condition) {
      id
      recipeId
      order
      description
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteStep = /* GraphQL */ `
  mutation DeleteStep(
    $input: DeleteStepInput!
    $condition: ModelStepConditionInput
  ) {
    deleteStep(input: $input, condition: $condition) {
      id
      recipeId
      order
      description
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createFoodMaster = /* GraphQL */ `
  mutation CreateFoodMaster(
    $input: CreateFoodMasterInput!
    $condition: ModelFoodMasterConditionInput
  ) {
    createFoodMaster(input: $input, condition: $condition) {
      id
      name
      yomi
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFoodMaster = /* GraphQL */ `
  mutation UpdateFoodMaster(
    $input: UpdateFoodMasterInput!
    $condition: ModelFoodMasterConditionInput
  ) {
    updateFoodMaster(input: $input, condition: $condition) {
      id
      name
      yomi
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFoodMaster = /* GraphQL */ `
  mutation DeleteFoodMaster(
    $input: DeleteFoodMasterInput!
    $condition: ModelFoodMasterConditionInput
  ) {
    deleteFoodMaster(input: $input, condition: $condition) {
      id
      name
      yomi
      createdAt
      updatedAt
      __typename
    }
  }
`;
